(ns app.front.view.admin.commands.dedupe-embeddings
  (:require [app.front.ui :as ui]
            [app.front.view.group.admin.common :as acommon]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(defn- deleted-count-message [deleted-count]
  (str deleted-count
       " duplicate embedding"
       (when (not= 1 deleted-count) "s")
       " deleted"))

(rf/reg-event-fx ::dedupe-embeddings
  (fn [_ _]
    {:comm/command {:command    :admin/dedupe-embeddings
                    :method     :post
                    :on-success [::dedupe-embeddings.success]}}))

(rf/reg-event-fx ::dedupe-embeddings.success
  (fn [_ [_ _ {:keys [deleted-count]}]]
    {:dispatch [:notifications/add :toast :success :success (deleted-count-message deleted-count)]}))

(defn view [match]
  (let [tr (<sub [:tr])]
    [acommon/admin-page (util/mmap {:title "Dedupe vector database embeddings"} match)
     [:section
      [:h2 "Dedupe embeddings"]
      [ui/help "Delete duplicate vector database embeddings with the same text and group ID. One embedding from each duplicate set will be retained."]
      [:div.flex.items-end
       [ui/modal-confirmation-button
        (util/mmap {:on-yes-click        #(>evt [::dedupe-embeddings])
                    :trigger-button-opts {:kind :danger}
                    :trigger-button-text "Dedupe embeddings"}
                   tr)
        [:p "Are you sure you want to permanently delete duplicate vector database embeddings?"]]]]]))

(def route
  {:name :view/admin.commands.dedupe-embeddings
   :view view})
